import React from 'react'

const NovelDarkICon = props => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24.000000 24.000000" preserveAspectRatio="xMidYMid meet" {...props}>   
        <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"fill="#000000" stroke="none">
            <path d="M42 118 l3 -103 75 -1 75 -1 -72 4 c-65 3 -73 6 -73 23 0 18 7 20 70
            20 l70 0 0 80 0 80 -75 0 -76 0 3 -102z m98 62 c0 -5 -11 -10 -25 -10 -14 0
            -25 5 -25 10 0 6 11 10 25 10 14 0 25 -4 25 -10z m20 -30 c0 -5 -20 -10 -45
            -10 -25 0 -45 5 -45 10 0 6 20 10 45 10 25 0 45 -4 45 -10z"/>
            <path d="M98 33 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
        </g>
    </svg>
    
)

export default NovelDarkICon
